import { render, staticRenderFns } from "./comp_ProductPage-MainContainer.vue?vue&type=template&id=6d196dbd&scoped=true&"
import script from "./comp_ProductPage-MainContainer.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPage-MainContainer.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductPage-MainContainer.vue?vue&type=style&index=0&id=6d196dbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d196dbd",
  null
  
)

export default component.exports